// extracted by mini-css-extract-plugin
export default {"isBetaUserContainer":"IsBetaUserToggle_isBetaUserContainer__dlAG4"};